import { ParamKey } from 'shared/types/QueryModel'

export const orderFilters: ParamKey[] = [
  'branch',
  'delivery_type',
  'status',
  'delivery_way',
  'payment_method',
]

export const orderParams: ParamKey[] = [
  ...orderFilters,
  'search',
  'start_date',
  'end_date',
]
